import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';

const CarEditForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { car } = location.state || {}; // Get car details from state
  const [imageUrls, setImageUrls] = useState(car.imagess || []); // Initialize with existing images if available

  const [loading, setLoading] = useState(true);
  const handleUpload = async (event) => {
    try {
      // Retrieve the images from the input
      const images = event.target.files;
      console.log(car.imagess)
      // Convert the images to an array if it's not an array already (useful if it's a FileList)
      const imageArray = Array.isArray(images) ? images : Array.from(images);
  
      // Retrieve the existing images from car.images (assuming it's an array of URLs)
      const existingImages = car.imagess || [];
  
      // Map each image to a promise that handles the upload
      const uploadPromises = imageArray.map((image) => {
        const formData = new FormData();
        formData.append("file", image);
  
        // You can append the transformation parameters directly here for resizing the image
        formData.append("upload_preset", "checking"); // Replace with your Cloudinary upload preset
        formData.append("folder", "ZOOM AUTOS");
  
        // Return the promise of the axios request for this image upload
        return axios
          .post(
            `https://api.cloudinary.com/v1_1/db2so7dyd/image/upload`, // Replace with your Cloudinary cloud name
            formData
          )
          .then((response) => {
            // Get the URL of the uploaded image
            const imageUrl = response.data.secure_url;
  
            // Apply the transformation for resizing
            const transformedImageUrl = `${imageUrl}?w_600,h_900,c_fill`;
  
            return transformedImageUrl; // Return the transformed image URL
          })
          .catch((error) => {
            console.error("Error uploading image: ", error);
            return null; // Return null if there's an error
          });
      });
  
      // Wait for all the uploads to complete in parallel
      const uploadedImageUrls = await Promise.all(uploadPromises);
  
      // Filter out any null responses due to upload errors
      const validImageUrls = uploadedImageUrls.filter((url) => url !== null);
  
      // Combine the existing image URLs with the newly uploaded ones
      const allImageUrls = [...existingImages, ...validImageUrls];
      console.log(allImageUrls);
      // Update the state with the combined image URLs
      setImageUrls(allImageUrls);
  
      return allImageUrls;
    } catch (error) {
      console.error('Error in parallel image upload:', error);
      return [];
    }
  };
  
  // Set up react-hook-form
  const { control, handleSubmit, setValue, formState: { errors } } = useForm();

  // Load car data into form on component mount
  useEffect(() => {
    if (car) {
      // Populate form fields with car data using setValue
      setValue('manufacturer', car.manufacturer);
      setValue('model', car.model);
      setValue('variant', car.variant);
      setValue('year', car.year);
      setValue('mileage', car.mileage);
      setValue('attention', car.attention);
      setValue('transmission', car.transmission);
      setValue('exteriorColor', car.exteriorColor);
      setValue('interiorColor', car.interiorColor);
      setValue('capacity', car.capacity);
      setValue('seats', car.seats);
      setValue('doors', car.Doors);
      setValue('owner', car.owner);
      setValue('CarType', car.CarType);
      setValue('description', car.description);
      setValue('Ulez', car.Ulez);
      setValue('keys', car.keys);
      setValue('ServiceHistory', car.ServiceHistory);

      setValue('imagess', car.imagess);
      setValue('ServiceHistory', car.ServiceHistory)
      setValue('exteriorCondition', car.exteriorCondition);
      setValue('interiorCondition', car.interiorCondition);
      setValue('accident', car.accident);
      setValue('imagess', car.imagess);
      setValue('videourl', car.videourl);
      setLoading(false);
    } else {
      setLoading(false);
      console.error('No car found for editing.');
    }
  }, [car, setValue]);


  const ImageGallery = ({ images = [], videoUrl }) => {
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [currentImages, setCurrentImages] = useState(images);
  // Helper function to generate the appropriate video embed URL
  const getEmbedUrl = (url) => {
    if (url.includes("youtube.com") || url.includes("youtu.be")) {
      const videoId = url.split("v=")[1]?.split("&")[0] || url.split("/").pop();
      return `https://www.youtube.com/embed/${videoId}`;
    } else if (url.includes("vimeo.com")) {
      const videoId = url.split("/").pop();
      return `https://player.vimeo.com/video/${videoId}`;
    } else if (url.includes("drive.google.com")) {
      const videoId = url.split("/d/")[1]?.split("/")[0];
      return `https://drive.google.com/file/d/${videoId}/preview`;
    }
    return null;
  };
  const videoEmbedUrl = videoUrl ? getEmbedUrl(videoUrl) : null;
    // Combine video URL and images into a single array for easier navigation
    const media = videoUrl ? [videoEmbedUrl, ...currentImages] : [...currentImages];
  
    if (media.length === 0) return null;
  
    // Determine if the media is a video
    const isVideo = (url) =>
      url.includes("youtube.com") ||
      url.includes("youtu.be") ||
      url.includes("vimeo.com") ||
      url.includes("drive.google.com");
  
    // Navigate to the previous item
    const handlePrevClick = () => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === 0 ? media.length - 1 : prevIndex - 1
      );
    };
  
    // Navigate to the next item
    const handleNextClick = () => {
      setSelectedImageIndex((prevIndex) =>
        prevIndex === media.length - 1 ? 0 : prevIndex + 1
      );
    };
  
   
    // Handle image deletion
    const handleDelete = async (imageUrl) => {
      
      const confirmDelete = window.confirm(
        "Are you sure you want to delete this image?"
      );
    
      try {
        const response = await axios.post("https://zoomautos.co.uk/api/delete-image", {
          imageUrl,
        });
        console.log("Response:", response.data);
        car.imagess = car.imagess.filter((image) => image !== imageUrl);
        setImageUrls(car.imagess);

        
      } catch (error) {
        if (error.response) {
          // Server responded with a status outside the 2xx range
          console.error("Server error:", error.response.data);
          console.error("Status code:", error.response.status);
        } else if (error.request) {
          // Request was made but no response was received
          console.error("No response received:", error.request);
        } else {
          // Something else caused the error
          console.error("Error setting up request:", error.message);
        }
      }
    }
  
    return (
      <div className="image-gallery">
        <div
          className="arrow left-arrow"
          onClick={handlePrevClick}
          role="button"
          aria-label="Previous item"
          
        >
          &#9664;
        </div>
        <div className="main-media">
          {isVideo(media[selectedImageIndex]) ? (
            <iframe
              src={media[selectedImageIndex]}
              frameBorder="0"
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Car Video"
              className="main-video"
            ></iframe>
          ) : (
            <>
            <div style={{display:'flex', flexDirection:'column'}}>
              <img
                src={media[selectedImageIndex]}
                alt="Car"
                className="mains-image"
              />
              <button
                onClick={() => handleDelete(media[selectedImageIndex])}
                className="contact-button"
                type="button"
                style={{width:'50px'}}
              >
                Delete
              </button>
              </div>
            </>
          )}
        </div>
        <div
          className="arrow right-arrow"
          onClick={handleNextClick}
          role="button"
          aria-label="Next item"
          
        >
          &#9654;
        </div>
        <div className="thumbnails-container">
          {media.map((item, index) => (
            <div
              key={index}
              className={`thumbnail-wrapper ${
                selectedImageIndex === index ? "active" : ""
              }`}
            >
              {isVideo(item) ? (
                <iframe
                  src={item}
                  frameBorder="0"
                  allow="autoplay; encrypted-media"
                  allowFullScreen
                  title={`Thumbnail Video ${index + 1}`}
                  className="thumbnail-video"
                  
                  onMouseEnter={() => setSelectedImageIndex(index)}
                ></iframe>
              ) : (
                <img
                  src={item}
                  alt={`Thumbnail ${index + 1}`}
                  className="thumbnail-image"
                  onMouseEnter={() => setSelectedImageIndex(index)}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    );
  };
  const onSubmit = async (data) => {
    try {
      data.imagess=imageUrls;
      console.log(data.imagess);
      const response = await axios.put(`https://zoomautos.co.uk/api/cars/edit/${car._id}`, data);
      if (response.status === 200) {
        alert('Car details updated successfully!');
        navigate(`/Inventory/${car._id}`, { state: { car: response.data } });
      } else {
        alert('Failed to update car details. Please try again.');
      }
    }
    catch (error) {
      console.error('Error updating car details:', error);
    }
  };

  if (loading) {
    return <p>Loading car details...</p>;
  }

  return (
    <div className="sell-vehicle-form" style={{margin:'auto', marginTop:'150px', marginBottom:'20px'}}>
      <h1>Edit Car Details</h1>
      <div className="form-section">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className='form-row'>
        <div className="form-group">
          <label>Manufacturer:</label>
          <Controller
            name="manufacturer"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
              />
            )}
          />
        </div>

        <div className="form-group">
          <label>Model:</label>
          <Controller
            name="model"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
              />
            )}
          />
        </div>
        </div>
<div className='form-row'>
        <div className="form-group">
          <label>Variant:</label>
          <Controller
            name="variant"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
              />
            )}
          />
        </div>

        <div className="form-group">
          <label>Year:</label>
          <Controller
            name="year"
            control={control}
            render={({ field }) => (
              <input
                type="number"
                {...field}
              />
            )}
          />
        </div>
        </div>
<div className='form-row'>
        <div className="form-group">
          <label>Mileage:</label>
          <Controller
            name="mileage"
            control={control}
            render={({ field }) => (
              <input
                type="number"
                {...field}
              />
            )}
          />
        </div>
        <div className="form-group">
          <label>Exterior Color:</label>
          <Controller
            name="exteriorColor"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
              />
            )}
          />
        </div>

        <div className="form-group">
          <label>Interior Color:</label>
          <Controller
            name="interiorColor"
            control={control}
            render={({ field }) => (
              <input
                type="text"
                {...field}
              />
            )}
          />
        </div>
        
</div>

<div className='form-row'>
<div className="form-group">
  <label>Transmission:</label>
  <Controller
    name="transmission"
    control={control}
    render={({ field }) => (
      <select {...field}>
  <option value="" disabled>
    Transmission Type
  </option>
  <option value="Automatic">Automatic</option>
  <option value="Manual">Manual</option>
      </select>
    )}
  />
</div>
<div className="form-group">
          <label>Seats:</label>
          <Controller
            name="seats"
            control={control}
            render={({ field }) => (
              <select {...field}>
                <option value="" disabled hidden>
    No. of Seats
  </option>
  <option value="2">2</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="7">7</option>
  
              </select>
            )}
          />
        </div>
        </div>
        <div className='form-row'>


        <div className="form-group">
          <label>Doors:</label>
          <Controller
            name="doors"
            control={control}
            render={({ field }) => (
              <select {...field}>
                <option value="" disabled hidden>
    No. of Seats
  </option>
  <option value="2">2</option>
  <option value="4">4</option>
  <option value="5">5</option>
  <option value="7">7</option>
  
              </select>
            )}
          />
        </div>
        <div className="form-group">
          <label>Keys:</label>
          <Controller
            name="keys"
            control={control}
            render={({ field }) => (
              <select {...field}>
                
  <option value="" disabled hidden>
    Number of keys
  </option>
  <option value="1">1</option>
  <option value="2">2</option>
  
              </select>
            )}
          />
        </div>
        <div className="form-group">
          <label>Car Type:</label>
          <Controller
            name="CarType"
            control={control}
            render={({ field }) => (
              <select {...field}>
                
                <option value="" disabled hidden>
    Car Type
  </option>
  <option value="SEDAN">SEDAN</option>
  <option value="SUV">SUV</option>
  <option value="HATCHBACK">HATCHBACK</option>
  <option value="COUPE">COUPE</option>
  <option value="VAN">VAN</option>
  <option value="CONVERTIBLE">SUPER CAR</option>
  <option value="SALOON">SALOON</option>
  <option value="ESTATE">ESTATE</option>
              </select>
            )}
          />
        </div>
        

</div>
        
        <div className="form-group">
          <label>Capacity (L):</label>
          <Controller
            name="capacity"
            control={control}
            render={({ field }) => (
              <input
                type="number"
                {...field}
              />
            )}
          />
        </div>


        <div className="form-group">
        <label>Owner:</label>
<Controller
  name="owner"
  control={control}
  rules={{
    required: 'Owner is required',
    min: {
      value: 1,
      message: 'Owner must be greater than or equal to 1',
    }
  }}
  render={({ field, fieldState: { error } }) => (
    <div>
      <input
        type="number"
        {...field}
        placeholder="Enter owner count"
        min="1" // Ensures input cannot go below 1
        step="1" // Allows increment/decrement in whole numbers
      />
      {error && <span style={{ color: 'red' }}>{error.message}</span>}
    </div>
  )}
/>

        </div>

        <div className="form-group">
          <label>Description:</label>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <textarea
                {...field}
              />
            )}
          />
        </div>

        <div className="form-group">
          <label>Ulez Exempt:</label>
          <Controller
            name="Ulez"
            control={control}
            render={({ field }) => (
              <select {...field}>
                <option value="" disabled hidden>
      Ulez exempt?
    </option>
    <option value="yes">Yes</option>
    <option value="no">No</option>
              </select>
            )}
          />
        </div>
        <div className="form-group">
          <label>Service History</label>
          <Controller
            name="ServiceHistory"
            control={control}
            render={({ field }) => (
              <select {...field}>
      <option value="" disabled hidden>
      Service History
    </option>
    <option value="Full Service Histroy">Full Service History</option>
    <option value="Full Dealership Histroy">Full Dealership History</option>
    <option value="Part Service Histroy">Part Service History</option>
    <option value="No Service Histroy">No Service History</option>
              </select>
            )}
          />
        </div>

        <div className="form-group">
       
        <label>What is the Exterior Condition?</label>
<div className="radiocontainer">
  <Controller
    name="exteriorCondition"
    control={control}
    rules={{ required: 'Exterior condition is required' }}
    render={({ field }) => (
      <>
        {['Poor', 'Average', 'Good', 'Clean', 'Excellent', 'New'].map((condition) => (
          <label key={condition}>
            <input
              type="radio"
              {...field}
              value={condition}
              checked={field.value === condition} // Ensure the correct radio is selected
            />
            <span>{condition}</span>
          </label>
        ))}
      </>
    )}
  />
  {errors.exteriorCondition && (
    <span style={{ color: 'red' }}>{errors.exteriorCondition.message}</span>
  )}
</div>
</div>
<div className="form-group">
       
<label>What is the Interior Condition?</label>
<div className="form-row">
  <div className="radiocontainer">
    <Controller
      name="interiorCondition"
      control={control}
      rules={{ required: 'Interior condition is required' }}
      render={({ field }) => (
        <>
          {['Poor', 'Average', 'Good', 'Clean', 'Excellent', 'New'].map((condition) => (
            <label key={condition}>
              <input
                type="radio"
                {...field}
                value={condition}
                checked={field.value === condition} // Ensures the correct radio is selected
              />
              <span>{condition}</span>
            </label>
          ))}
        </>
      )}
    />
  </div>
</div>
{errors.interiorCondition && (
  <p className="error-message">{errors.interiorCondition.message}</p>
)}
</div>
<div className='form-group'>
<label>Has This Car Ever Been in an Accident?</label>
<div className="form-row">
  <div className="radiocontainer">
    <Controller
      name="accident"
      control={control}
      rules={{ required: 'Accident history is required' }}
      render={({ field }) => (
        <>
          <label>
            <input
              type="radio"
              {...field}
              value="Yes"
              checked={field.value === 'Yes'} // Ensures the correct radio is selected
            />
            <span>Yes</span>
          </label>
          <label>
            <input
              type="radio"
              {...field}
              value="No"
              checked={field.value === 'No'} // Ensures the correct radio is selected
            />
            <span>No</span>
          </label>
        </>
      )}
    />
  </div>
</div>
{errors.accident && <span className="error-message">{errors.accident.message}</span>} {/* Error message display */}
</div>



        <div className="form-group">
          <label>Images:</label>
          <input
            type="file"
            name="imagess"
            multiple
            onChange={handleUpload}
          />
        </div>
        <ImageGallery images={car.imagess} videoUrl={car.videourl} /> {/* Include the image gallery */}

        <button type="submit" className='contact-button'>Save Changes</button>
      </form>
    </div>
    </div>
  );
};

export default CarEditForm;
